export default __webpack_public_path__ + "static/media/small_youtube_line.4980a72f.svg";